import React from 'react'

import {
  Box,
  Heading3,
  Display,
  AlignItems,
  Color,
  Space,
  FontWeight,
  FlexDirection,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { Cta, useGetCtaProps } from '../Cta'
import { ConveniencesList } from './ConveniencesList'
import { ConveniencesContainer, ValueForMoneyContainer } from './containers.styled'
import { title, valueForMoneyTrackingSectionName } from './data'

export const ValueForMoney = () => {
  const { ctaUri, ctaText } = useGetCtaProps()

  return (
    <ValueForMoneyContainer
      height={[null, '711px']}
      paddingH={[null, 6, 8]}
      paddingV={[null, 10, 0]}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={[null, null, JustifyContent.Center]}
      alignItems={[null, null, AlignItems.Center]}
      data-testid={valueForMoneyTrackingSectionName}
    >
      <Box width="100%" maxWidth="1071px">
        <ConveniencesContainer
          width={[null, '449px']}
          paddingH={8}
          paddingV={8}
          paddingRight={[8, 16]}
          paddingBottom={4}
        >
          <Heading3 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold}>
            {title}
          </Heading3>
          <Space size={6} direction="vertical" />
          <ConveniencesList />
          <Space size={2} direction="vertical" />
          <Box>
            <Cta ctaUri={ctaUri} trackingSectionName={valueForMoneyTrackingSectionName}>
              {ctaText}
            </Cta>
          </Box>
        </ConveniencesContainer>
      </Box>
      {/* This box padds the bottom of the container on small screens so that the background is visible */}
      <Box height={['224px', '0']} />
    </ValueForMoneyContainer>
  )
}
